import {
  IManualExtendedData,
  isManualExtendedData,
  TransactionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class ApproveManualTransaction
  implements ITransactionAction<IManualExtendedData>
{
  icon = 'done';
  label = 'Approve';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isManualExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IManualExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(data, isManualExtendedData).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(data: ITransactionActionsData<IManualExtendedData>): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.approve(
      data.invoice,
      data.latestTransaction,
      'Approve Transaction'
    );
    this.inProgress$.next(false);
  }
}
